import { render, staticRenderFns } from "./DocumentosNewOrEdit.vue?vue&type=template&id=31ff886e&scoped=true&"
import script from "./DocumentosNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentosNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosNewOrEdit.vue?vue&type=style&index=0&id=31ff886e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff886e",
  null
  
)

export default component.exports